module.exports = __webpack_public_path__ + "img/avatar-screen.a4208e94.jpg";